import { recipes } from "../../../static/libs/recipes.json";
import mixologyData from "./../../../static/libs/mixology"


const state = {
    activeRecipe: 0,
    gatedRecipeList: [],
    filteredList: [],
    ageGatedFilters: [],
    activeFilter: "all",
    activeSubFilter: "",
    filterBar: false,
    subFilterBar: false,
};

const getters = {
    getActiveRecipe: state => state.activeRecipe,
    getActiveFilter: state => state.activeFilter,
    getAgeGatedFilters: state => state.ageGatedFilters,
    getFilteredList: state => state.filteredList,
    getActiveSubFilter: state => state.activeSubFilter,
    isFilterBarOpen: state => state.filterBar,
    isSubFilterBarOpen: state => state.subFilterBar,
    InitialList: state => state.gatedRecipeList,
};

const actions = {
    async setActiveRecipe({commit}, payload){
        commit("setARec", await payload)
    },
    setActiveFilter({commit}, payload){
        commit("updateActivefilters", payload)
    },
    toggleFilterBar({commit}) {
        commit("updateActiveBar")
    },
    async setInitalList({commit}, ofAge){
        const payload = (ofAge) ? recipes : recipes.filter(recipe => !recipe.cocktail)
        // const shuffle = (array) => array.sort((a, b) => 0.5 - Math.random())
        commit("setAgeGatedFilters", ofAge)
        commit("setGatedRecipeList", await payload)
        commit("setFilteredList")
    },
    applyFilter({commit}){
        commit("setFilteredList")
        commit("setARec", 0)
    },
    toggleSubFilterBar({commit}) {
        commit("updateActiveSubBar")
    },
    closeSubFilterBar({commit}) {
        commit("closeActiveSubBar")
    }
};

const mutations = {
    setARec: (state, newActiveRecipe) => (state.activeRecipe = newActiveRecipe),
    updateActivefilters: (state, newFilter) => {
        state.activeFilter = newFilter.active
        state.activeSubFilter = newFilter.sub
    },
    setAgeGatedFilters: (state, ofAge) => {
        if(ofAge){
            state.ageGatedFilters = mixologyData.FILTERS
        } else {
            state.ageGatedFilters = mixologyData.FILTERS.filter(item => {
                return item.name !== "spirit" && item.name !== "cocktails" && item.name !== "mocktails"
            })
        }
    },
    updateActiveBar: (state) => (state.filterBar = !state.filterBar),
    updateActiveSubBar: (state) => (state.subFilterBar = !state.subFilterBar),
    closeActiveSubBar: (state) => (state.subFilterBar = false),
    setGatedRecipeList: (state, payload) => (state.gatedRecipeList = payload),
    setFilteredList: (state) => {
        let payload = []
        const bySubList = item => item.filters.includes(state.activeSubFilter)
        const byCocktails = item => item.cocktail
        const byMocktails = item => !item.cocktail
        const byFeatured = item => item.featured

        switch(state.activeFilter){
            case "flavor":
            case "spirit":
                if(state.activeSubFilter) {
                    payload = state.gatedRecipeList.filter(bySubList)
                    state.subFilterBar = false
                } else {
                    payload = state.filteredList; 
                    state.subFilterBar = true
                } 
                break;
            case "cocktails": payload = state.gatedRecipeList.filter(byCocktails); break;
            case "mocktails": payload = state.gatedRecipeList.filter(byMocktails); break;
            case "featured": payload = state.gatedRecipeList.filter(byFeatured); break;
            default: payload = state.gatedRecipeList
        }

        state.filteredList = payload
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mixology.js